module.exports = __webpack_public_path__ + "02_glasses_black.0bea1eda.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer4/02_glasses_black.png
// module id = Pkhn
// module chunks = 0